import React, { useEffect } from "react";
import "./home.css";
import vid from "./assets/comingSoon.mp4";
import HomeHeader from "./new/components/homeHeader";

const ComingSoon = () => {
  useEffect(() => {
    const videoElement = document.getElementById("comingSoonVideo");
    if (videoElement) {
      videoElement.muted = true;
      videoElement.play().catch((error) => {
        // Catch any autoplay restriction errors
        console.log("Autoplay failed:", error);
      });
    }
  }, []);

  return (
    <div>
      <HomeHeader
        isTitle={false}
        title={""}
        headerColor="header-white"
        navItems={true}
      />
      <div className="comingSoonContainer">
        {/* Video background */}
        <video
          playsInline=""
          autoPlay=""
          muted=""
          loop
          id="comingSoonVideo"
          preload="auto" /* Ensure the video preloads for smoother autoplay */
        >
          <source src={vid} type="video/mp4" />
          <source src={vid} type="video/ogg" />
        </video>

        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "5%",
          }}
        >
          <p className="comingTitle">Coming Soon</p>

          <p className="comingDescription">
            {" "}
            Have questions or want to learn more? Contact us for details before
            we go live!
          </p>

          <a className="contactButton" href="/contact-us">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
